import palette from '../palette'

export default {
  root: {
    '&:nth-of-type(even)': {
      backgroundColor: '#F8F8F8'
    },
    '&$selected': {
      backgroundColor: palette.background.default
    },
    '&$hover': {
      '&:hover': {
        backgroundColor: palette.background.default
      }
    }
  }
}
